import { createContext, useContext } from 'react';

import { MultiSelectContextValue, SelectContextValue } from './types';

export const SelectContext = createContext<SelectContextValue>({
  isInsideWrapper: false,
});

export const useSelectContext = () => useContext(SelectContext);

export const MultiSelectContext = createContext<MultiSelectContextValue | null>(
  null,
);

export const useMultiSelectContext = () => useContext(MultiSelectContext);
